import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// web/src/components/ui/ConfidenceBar.tsx
// Horizontal bar visualising a 0.0–1.0 confidence score.
// Color: emerald ≥CONFIDENCE_HIGH_PCT% | amber ≥CONFIDENCE_MED_PCT% | rose below
import { CONFIDENCE_HIGH_PCT, CONFIDENCE_MED_PCT } from "../../lib/displayConfig";
export function ConfidenceBar({ value, showLabel = false, className = "", height = "sm", }) {
    const pct = Math.min(100, Math.max(0, value * 100));
    const barColor = pct >= CONFIDENCE_HIGH_PCT ? "bg-emerald-500" :
        pct >= CONFIDENCE_MED_PCT ? "bg-amber-500" :
            "bg-rose-500";
    const labelColor = pct >= CONFIDENCE_HIGH_PCT ? "text-emerald-400" :
        pct >= CONFIDENCE_MED_PCT ? "text-amber-400" :
            "text-rose-400";
    const heightClass = height === "xs" ? "h-0.5" :
        height === "sm" ? "h-1" :
            "h-1.5";
    return (_jsxs("div", { className: `flex items-center gap-2 ${className}`, children: [_jsx("div", { className: `flex-1 rounded-full bg-slate-800 overflow-hidden ${heightClass}`, children: _jsx("div", { className: `h-full rounded-full transition-all duration-500 ${barColor}`, style: { width: `${pct}%` }, role: "progressbar", "aria-valuenow": pct, "aria-valuemin": 0, "aria-valuemax": 100 }) }), showLabel && (_jsxs("span", { className: `text-xs font-medium tabular-nums w-8 text-right ${labelColor}`, children: [Math.round(pct), "%"] }))] }));
}
